/*
 * fn: setCookie
 *
 * Sets a cookie
 *
 */
import { type CookieSetOptions } from 'universal-cookie'

import { getCookies } from './getCookies'

export const setCookie = (key: string, value: string, options?: CookieSetOptions) => {
  getCookies().set(key, value, { httpOnly: false, path: '/', ...options })
}
